const chords = {
    Am: ['A1', 'C2', 'E2', 'A2', 'C3', 'E3', 'A3', 'C4', 'E4', 'A4', 'C5', 'E5', 'A5', 'C6', 'E6'],
    Em: ['E1', 'G1', 'B1', 'E2', 'G2', 'B2', 'E3', 'G3', 'B3', 'E4', 'G4', 'B4', 'E5', 'G5', 'B5'],
}

export default chords;